import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styles from 'wienenergiedesignsystem/components/Content/Content.module.scss';
import React from 'react';
import classNames from 'classnames';

var Content = function Content(_ref) {
  var _classNames;

  var as = _ref.as,
      align = _ref.align,
      withParser = _ref.withParser,
      children = _ref.children,
      size = _ref.size,
      noSpacing = _ref.noSpacing,
      notResponsive = _ref.notResponsive,
      className = _ref.className,
      theme = _ref.theme,
      tabIndex = _ref.tabIndex,
      forwardedRef = _ref.forwardedRef,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "align", "withParser", "children", "size", "noSpacing", "notResponsive", "className", "theme", "tabIndex", "forwardedRef"]);

  var Element = {
    as: as
  };
  return /*#__PURE__*/React.createElement(Element.as, Object.assign({
    className: classNames(styles.content, styles[size], styles[align], styles[theme], (_classNames = {}, _classNames[styles.notResponsive] = notResponsive, _classNames[styles.noSpacing] = noSpacing, _classNames), className)
    /* eslint-disable react/no-danger */
    ,
    dangerouslySetInnerHTML: withParser ? {
      __html: withParser && children
    } : null,
    tabIndex: tabIndex || undefined,
    ref: forwardedRef
  }, props), !withParser ? children : null);
};

Content.defaultProps = {
  withParser: false,
  notResponsive: false,
  noSpacing: false,
  size: 'md',
  children: null,
  className: null,
  align: null,
  as: 'p',
  theme: 'default',
  tabIndex: null,
  forwardedRef: null
};
export default Content;